import Vue from 'vue'
import dayjs from 'dayjs'
require('dayjs/locale/ar')

dayjs.extend(require('dayjs/plugin/utc'))
dayjs.extend(require('dayjs/plugin/timezone'))
dayjs.extend(require('dayjs/plugin/isSameOrBefore'))
dayjs.extend(require('dayjs/plugin/isSameOrAfter'))

dayjs.tz.setDefault('Africa/Tripoli')

Vue.prototype.$dayjs = dayjs
